import * as actions from "store/actions/subscription/detail";
import ISubscription from "Types/Subscription";

export interface SubscriptionDetailState {
	item: ISubscription;
	loading: boolean;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: SubscriptionDetailState = {
	item: {},
	loading: false,
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_SUBSCRIPTION: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_SUBSCRIPTION_SUCCESS: {
			return {
				...initialState,
				item: payload
			};
		}
		case actions.GET_SUBSCRIPTION_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
